import angular from 'angular';

angular
  .module('dashboard')

  .controller('EnvelopeDetailsCtrl', [
    '$scope',
    '$sce',
    '$uibModal',
    '$window',
    'EnvelopeService',
    'envelope',
    '$state',
    'activeTabName',
    function($scope, $sce, $uibModal, $window, EnvelopeService, envelope, $state, activeTabName) {
      $scope.container = null;
      $scope.envelope = envelope;
      $scope.envelope.$promise.then(function(data) {
        $scope.container = data.container;
      });

      $scope.back = function() {
        if (!activeTabName) {
          $window.history.back();
        } else {
          $state.go('envelopes', { tabName: activeTabName, specificForm: null, keepFilter: true });
        }
      };

      // Affichage de la fenêtre detaillant le contenu d'une enveloppe.
      $scope.openContentPopup = function() {
        return $uibModal
          .open({
            component: 'envelopeContent',
            size: 'lg',
            resolve: {
              envelope: function() {
                return $scope.envelope;
              }
            }
          })
          .result.then(
            function() {},
            function() {}
          );
      };

      // Affichage de la fenêtre de detail du container d'une enveloppe.
      $scope.openContainerPopup = function() {
        return $uibModal
          .open({
            templateUrl: require('./envelope-container-popup.html'),
            controller: 'EnvelopeContainerCtrl',
            resolve: {
              container: function() {
                return $scope.container;
              }
            }
          })
          .result.then(
            function() {},
            function() {}
          );
      };
    }
  ]);
